<div>{{formatedValue || '&nbsp;'}}</div>